<template>
    <div class="layer">
        <el-table
            :data="tableData.slice(
              (currentPage - 1) * pageSize,
              currentPage * pageSize
            )"
            height="calc(100% - 40px)"
            border
            style="width: 100%;">
            <el-table-column
            prop="Name"
            label="姓名"
            sortable
            >
            </el-table-column>
            <el-table-column
            prop="PhoneNum"
            label="手机号"
            sortable
            >
            </el-table-column>
            <el-table-column
            prop="CompanyName"
            label="公司名"
            sortable
            >
            </el-table-column>
            <el-table-column
            prop="Demand"
            label="需求"
            sortable
            >
            </el-table-column>
        </el-table>
        <el-pagination
        style="border:1px solid #EBEEF5;border-top:none;padding:10px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20,50,100,10]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.length">
        </el-pagination>
    </div>
  
</template>
<style lang="scss" scoped>
    .layer{
        width: 100%;
        height: 100vh !important;
        min-height: unset !important;
        padding: 20px;
        box-sizing: border-box;
    }
</style>
<script>
import axios from 'axios';
export default {
    name:'DeliveryInfo',
    data(){
        return{
            tableData:[],
            currentPage: 1,
            pageSize: 20,
        }
    },
    mounted() {
        this.GetData();
    },
    methods:{
         handleSizeChange(val) {
           this.currentPage = 1;
           this.pageSize = val;
         },
         //当前页改变时触发 跳转其他页
         handleCurrentChange(val) {
           this.currentPage = val;
        },
        GetData(){
            let serviceUrl = process.env.VUE_APP_Domain+'/IGetUserinfo';
            axios({
            url: serviceUrl,
            method: 'get',
            }).then(res=>{
                if(res.data) {
                    this.tableData = res.data
                }
            })
        }
    }
}
</script>

<style>

</style>